/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import "./src/styles/global.css"
import '@everlywell/leaves/lib/style.css';

function addFont() {
  // add EW DM-Sans
  const link = document.createElement("link")
  link.rel = "stylesheet"
  link.type = "text/css"
  link.href = "https://cdn.everlywell.com/fonts/everly-font.css"
  document.head.appendChild(link)
}

// load the font before rendering the application to avoid a flicker
const onClientEntry = () => {
  addFont()
}

export { onClientEntry }
export { wrapRootElement } from "apollo/client"

export const onServiceWorkerUpdateReady = () => window.console.log('Service Worker Updated');
